import React from 'react';
import { objectOf, node, string } from 'prop-types';

export default class Tabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = { active: this.props.activeComponent };
    }

    isComponentActive(componentName) {
        return this.state.active === componentName;
    }

    addActiveClass(componentName) {
        if (this.isComponentActive(componentName)) {
            return 'active';
        }
        return '';
    }

    activateComponent(componentName) {
        this.setState({ active: componentName });
    }

    render() {
        const componentNames = Object.keys(this.props.components);
        return (
            <div className="edocket-detail-tabs">
                <div className="edocket-detail-tabs-labels">
                    {componentNames.map(component => (
                        <a
                            href={`#tab-${component}`}
                            className={`tabs-label ${this.addActiveClass(component)}`}
                            key={`label-${component}`}
                            onClick={() => this.activateComponent(component)}
                        >
                            {this.props.componentLabels[component]}
                        </a>
                    ))}
                </div>
                <div className="edocket-detail-tabs-contents">
                    {componentNames.map(component => (
                        <div
                            className={`tabs-single ${this.addActiveClass(component)}`}
                            key={`content-${component}`}
                        >
                            {this.props.components[component]}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

Tabs.propTypes = {
    activeComponent: string.isRequired,
    componentLabels: objectOf(string).isRequired,
    components: objectOf(node).isRequired
};
